/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: GPL-3.0-or-later
 */
/**
 * @param app app ID, e.g. "mail"
 * @param key name of the property
 * @param fallback optional parameter to use as default value
 * @throws if the key can't be found
 */
export function loadState(app, key, fallback) {
    const selector = `#initial-state-${app}-${key}`;
    if (window._nc_initial_state?.has(selector)) {
        return window._nc_initial_state.get(selector);
    }
    else if (!window._nc_initial_state) {
        window._nc_initial_state = new Map();
    }
    const elem = document.querySelector(selector);
    if (elem === null) {
        if (fallback !== undefined) {
            return fallback;
        }
        throw new Error(`Could not find initial state ${key} of ${app}`);
    }
    try {
        const parsedValue = JSON.parse(atob(elem.value));
        window._nc_initial_state.set(selector, parsedValue);
        return parsedValue;
    }
    catch (error) {
        console.error('[@nextcloud/initial-state] Could not parse initial state', { key, app, error });
        if (fallback !== undefined) {
            return fallback;
        }
        throw new Error(`Could not parse initial state ${key} of ${app}`, { cause: error });
    }
}
